import PaymentsDetails from './PaymentsDetails';

export default PaymentsDetails;
